<template>
    <div class="tournamentNavbar">
        <div class="tournamentNavbar_titleRow">
            <SboIcon
                name="event:worldCupColor"
                v-bind:size="24"
                class="tournamentNavbar_icon"
            />
            <h1 class="tournamentNavbar_title">
                {{ i18n.t('promotion_zone_3') }}
            </h1>
        </div>
        <div class="tournamentNavbar_tabs">
            <Navbar
                v-bind:isShowBottomRow="false"
                v-bind:isTransparent="true"
            >
                <template #topRow>
                    <NavbarMain>
                        <NavbarItem
                            v-for="tab in tabs"
                            v-bind:key="tab.routeName"
                            v-gtm:page="'K_TC'"
                            v-gtm:type="tab.gtmType"
                            v-gtm:@click
                            v-bind:name="tab.title"
                            v-bind:isActive="tab.isActive"
                            v-bind:onclick="tab.navigate"
                            v-bind:hasBottomRow="false"
                            v-bind:isActiveHasUnderline="true"
                        />
                    </NavbarMain>
                </template>
            </Navbar>
        </div>
    </div>
</template>

<script lang="ts" setup>
    import { storeToRefs } from 'pinia';
    import { computed } from 'vue';
    import { useRoute, useRouter } from 'vue-router';
    import SboIcon from '@/components/common/SboIcon.vue';
    import Navbar from '@/components/common/navbar/Navbar.vue';
    import NavbarItem from '@/components/common/navbar/NavbarItem.vue';
    import NavbarMain from '@/components/common/navbar/NavbarMain.vue';
    import { i18n } from '@/core/lib/i18n';
    import { AsiaRoutePage, SiteStyle } from '@/interface/enum';
    import { useToggleStore } from '@/store/toggleStore';

    const router = useRouter();
    const route = useRoute();

    const { isPromotionEnabled } = storeToRefs(useToggleStore(SiteStyle.Asia));

    const tabs = computed(() => {
        const list = [
            {
                title: i18n.t('tournament_center_header_overview'),
                routeName: AsiaRoutePage.TournamentOverview,
                gtmType: 'Overview',
                isActive: route.name === AsiaRoutePage.TournamentOverview,
                navigate: () => {
                    router.push({ name: AsiaRoutePage.TournamentOverview });
                },
                isShow: true,
            },
            {
                title: i18n.t('market_page_matches'),
                routeName: AsiaRoutePage.TournamentMatches,
                gtmType: 'Matches',
                isActive: route.name === AsiaRoutePage.TournamentMatches,
                navigate: () => {
                    router.push({ name: AsiaRoutePage.TournamentMatches });
                },
                isShow: true,
            },
            {
                title: i18n.t('tournament_center_header_promotion'),
                routeName: AsiaRoutePage.TournamentPromotion,
                gtmType: 'Promotion',
                isActive: route.name === AsiaRoutePage.TournamentPromotion,
                navigate: () => {
                    router.push({ name: AsiaRoutePage.TournamentPromotion });
                },
                isShow: isPromotionEnabled.value,
            },
        ];
        return list.filter(x => x.isShow);
    });
</script>

<style lang="scss" scoped>
@import "@/components/tournamentCenter/TournamentNavbar";
</style>
